import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu", "item"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick)
  }

  toggle(event) {
    event.preventDefault()
    this.openValue = !this.openValue
  }

  buttonKeydown(event) {
    if (event.key === "ArrowDown") {
      event.preventDefault()
      this.openValue = true
      this.focusItem(0)
    } else if (event.key === "ArrowUp") {
      event.preventDefault()
      this.openValue = true
      this.focusItem(this.itemTargets.length - 1)
    }
  }

  menuKeydown(event) {
    switch (event.key) {
      case "Escape":
        event.preventDefault()
        this.openValue = false
        this.buttonTarget.focus()
        break
      case "ArrowDown":
        event.preventDefault()
        this.focusNextItem()
        break
      case "ArrowUp":
        event.preventDefault()
        this.focusPreviousItem()
        break
      case "Home":
        event.preventDefault()
        this.focusItem(0)
        break
      case "End":
        event.preventDefault()
        this.focusItem(this.itemTargets.length - 1)
        break
      case "Tab":
        this.openValue = false
        break
    }
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.openValue = false
    }
  }

  openValueChanged(open, previousOpen) {
    if (previousOpen === undefined) return

    if (open) {
      this.menuTarget.classList.remove("hidden")
      this.buttonTarget.setAttribute("aria-expanded", "true")
      document.addEventListener("click", this.closeOnOutsideClick)
    } else {
      this.menuTarget.classList.add("hidden")
      this.buttonTarget.setAttribute("aria-expanded", "false")
      document.removeEventListener("click", this.closeOnOutsideClick)
    }
  }

  focusNextItem() {
    this.focusItem(this.currentItemIndex() + 1)
  }

  focusPreviousItem() {
    this.focusItem(this.currentItemIndex() - 1)
  }

  focusItem(index) {
    if (!this.itemTargets.length) return

    const wrappedIndex = (index + this.itemTargets.length) % this.itemTargets.length
    this.itemTargets[wrappedIndex].focus()
  }

  currentItemIndex() {
    const index = this.itemTargets.indexOf(document.activeElement)
    return index >= 0 ? index : 0
  }
}
